import "./App.css";
import "./responsive.css";

import { Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./components/layouts/Navbar";
import Footer from "./components/layouts/Footer";

/* ===========================
   KTL PAGES
=========================== */

import Dashboard from "./components/sections/Dashboard";
import Leaderboard from "./components/sections/Leaderboard";
import League from "./components/sections/League";
import Rewards from "./components/sections/Rewards";
import Profile from "./components/sections/Profile";
import History from "./components/sections/History";
import Admin from "./components/sections/Admin";

/* ===========================
   REOWN APPKIT
=========================== */

import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import {
  bsc,
  bscTestnet,
} from "@reown/appkit/networks";

import { BASE_URL } from "./constant";

/* ===========================
   APPKIT
=========================== */

const projectId = "7b037fb00655ef362c37f963e74a16b8";

createAppKit({
  adapters: [new EthersAdapter()],

  // BNB Mainnet + BNB Testnet
  networks: [
    bsc,
    bscTestnet,
  ],

  projectId,

  metadata: {
    name: "Kind Trading League",
    description:
      "Trade KIND, earn KP and climb the leaderboard.",
    url: BASE_URL,
    icons: [`${BASE_URL}/kindlogo.png`],
  },

  // Allow switching between Mainnet and Testnet
  enableNetworkSwitch: true,

  themeMode: "dark",

  themeVariables: {
    "--w3m-accent": "#ffcc66",
    "--w3m-color-mix": "#191a1b",
    "--w3m-color-mix-strength": 20,
    "--w3m-border-radius-master": "4px",
  },
});

/* ===========================
   LAYOUT
=========================== */

function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#050b08] text-white">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

/* ===========================
   APP
=========================== */

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to="/dashboard" replace />}
      />

      <Route
        path="/dashboard"
        element={
          <Layout>
            <Dashboard />
          </Layout>
        }
      />

      <Route
        path="/leaderboard"
        element={
          <Layout>
            <Leaderboard />
          </Layout>
        }
      />

      <Route
        path="/league"
        element={
          <Layout>
            <League />
          </Layout>
        }
      />

      <Route
        path="/rewards"
        element={
          <Layout>
            <Rewards />
          </Layout>
        }
      />

      <Route
        path="/profile"
        element={
          <Layout>
            <Profile />
          </Layout>
        }
      />

      <Route
        path="/history"
        element={
          <Layout>
            <History />
          </Layout>
        }
      />

      <Route
        path="/admin"
        element={
          <Layout>
            <Admin />
          </Layout>
        }
      />

      <Route
        path="*"
        element={<Navigate to="/dashboard" replace />}
      />
    </Routes>
  );
}

export default App;